export type AbschnittZustand = 'offen' | 'zu';

export interface DashboardLayout {
  abschnitte: Record<string, AbschnittZustand>;
  angehefteteProjekte: string[];
  ausgeblendeteProjekte: string[];
}

export function leeresLayout(): DashboardLayout {
  return { abschnitte: {}, angehefteteProjekte: [], ausgeblendeteProjekte: [] };
}
